import script from "./QualityTable.vue?vue&type=script&setup=true&lang=js"
export * from "./QualityTable.vue?vue&type=script&setup=true&lang=js"

import "./QualityTable.vue?vue&type=style&index=0&id=37d1a3fd&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37d1a3fd"]])

export default __exports__